import { newApi } from '@/Plugins/Axios'

import Rest from '../rest'

/******************************************************************************
 *  Users
 *****************************************************************************/

/**
 * @type {User}
 */
export default class User extends Rest {
    constructor() {
        super('/users')
		this.http = newApi
    }
	get(id){
		return this.http.post(`/users/${id}`)
	}
}
